import { AlertTriangle } from 'lucide-react';

// Предупреждение о точке, определённой через перенос с «Кассы доставки».
const TransferredPointWarning = () => (
  <span
    className="inline-flex"
    title="Заказ был перенесен на эту точку. Номер нового заказа может отличаться"
  >
    <AlertTriangle className="h-4 w-4 text-orange-500" />
  </span>
);

export default TransferredPointWarning;
